import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const TaglineBanner: React.FC = () => {
  const { t } = useTranslation();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <Box
      component="section"
      id="tagline"
      sx={{
        py: { xs: 6, md: 8 },
        background: 'linear-gradient(135deg, rgb(13, 13, 37) 0%, rgb(20, 20, 50) 100%)',
        color: 'white',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background:
            'radial-gradient(circle at 20% 30%, rgba(0, 245, 255, 0.10) 0%, transparent 50%), radial-gradient(circle at 80% 70%, rgba(255, 0, 255, 0.08) 0%, transparent 50%)',
          zIndex: 0,
        },
      }}
    >
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="h3"
            sx={{
              fontWeight: 800,
              fontSize: { xs: '1.6rem', sm: '2rem', md: '2.6rem' },
              lineHeight: 1.2,
              mb: 1.5,
              color: 'white',
            }}
          >
            {t('taglineBanner.text')}
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 800,
              fontSize: { xs: '1.6rem', sm: '2rem', md: '2.6rem' },
              lineHeight: 1.2,
              background: 'linear-gradient(45deg, #00F5FF, #FF00FF)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            {t('taglineBanner.sub')}
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
};

export default TaglineBanner;
